module.exports = __webpack_public_path__ + "static/a-gentleman-in-moscow-cf0d2aa29582145076b8f8ac39beb5d8.jpg";